import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import type {
  ArchivedBenefitAPIResponse,
  ArchivedResponseData,
  ArchivedSimplifiedPromotion,
  Pagination,
} from 'typings'
import { useFetch } from './useFetch'

function toSimplifiedPromotion(
  promotion: ArchivedBenefitAPIResponse
): ArchivedSimplifiedPromotion {
  return {
    beginDate: promotion.beginDate,
    id: promotion.idCalculatorConfiguration,
    name: promotion.name,
    endDate: promotion.endDate,
    type: promotion.type,
    isArchived: true,
  }
}

type Params = {
  page: number
  pageSize: number
  query: string
  options?: UseQueryOptions<UseArchivedPromotionsReturn>
}

export interface UseArchivedPromotionsReturn {
  pagination: Pagination
  items: ArchivedSimplifiedPromotion[]
}

export function useArchivedPromotions(params: Params) {
  const { fetcherWrapper } = useFetch()
  const { page, pageSize, query, options } = params

  const url = new URL(`/api/proxy/rnb/pvt/promotions`, window.location.origin)

  url.search = new URLSearchParams({
    archived: 'true',
    page: page.toString(),
    pageSize: pageSize.toString(),
    query,
  }).toString()

  async function fetcher() {
    return fetcherWrapper(url)
      .then((r) => r.json())
      .then((response: ArchivedResponseData) => {
        return {
          pagination: response.pagination,
          items: response.items.map(toSimplifiedPromotion),
        }
      })
  }

  return useQuery<UseArchivedPromotionsReturn>({
    queryKey: ['archived-promotions', page, pageSize, query],
    queryFn: fetcher,
    ...options,
  })
}
